//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AboutAuthor",

  props: {
    text: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {}
    },
  },

  computed: {
    userName() {
      return this.user?.profile?.nickname ?? this.user.username
    }
  }
}
